<template>
    <!-- 级联组件 -->
    <div class="vel-cascader">
        <!-- 级联选择框 -->
        <el-cascader
        v-if="!panel"
        v-model="value"
        :options="cascaderList"
        :props="props"
        :clearable="clearable"
        :show-all-levels="onlyLast"
        :collapse-tags="collapseTags"
        :filterable="filterable"
        :filter-method="filterFn"
        :placeholder="placeholder"
        :size="size"
        :disabled="disabled"
        :separator="separator"
        :debounce="debounce"
        :popper-class="popperClass"
        :before-filter="berforeFilterFn"
        @change="change"
        @expand-change="expandChange"
        @focus="focus"
        @blur="blur"
        @removeTag="removeTag"
        >   
            <!-- 自定义插槽 -->
            <template slot-scope="item">
                <slot :item="item">
                    {{item.data.label}}
                </slot>
            </template>
        </el-cascader>
        <!-- 级联面板 -->
        <el-cascader-panel
        v-else
        v-model="value"
        :options="cascaderList"
        :props="props"
        @change="change"
        @expand-change="expandChange"
        >
            <!-- 自定义插槽 -->
            <template slot-scope="item">
                <slot :item="item">
                    {{item.data.label}}
                </slot>
            </template>
        </el-cascader-panel>
    </div>
</template>
<script>
export default {
    name:"VelCascader",
    props:{
        initValue:Object,
        isDisable:Boolean,
        props:Object,
        isOnlyLast:Boolean,
        isCollapseTags:Boolean,
        isFilter:Boolean,
        size:String,
        filterFn:Function,
        placeholder:String,
        separator:String,
        debounce:Number,
        popperClass:String,
        berforeFilterFn:Function,
        isPanel:Boolean,
        cascaderList:{
            type:Array,
            required:true
        },
        isClearable:Boolean,
    },
    data() {
        return {
            value:null,
            disabled:false,
            onlyLast:false,
            collapseTags:false,
            filterable:false,
            panel:false,
            clearable:true,
        };
    },
    created() {
        this.initDataFn()
        // this.getValue()
    },
    watch: {
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            }
        }
    },
    methods: {
        getValue(){
            this.initValue ? this.value = this.initValue :  this.value
        },
        initDataFn(){
            this.isDisable ? this.disabled = true : this.disabled
            this.isOnlyLast ? this.onlyLast = true  : this.onlyLast
            this.isCollapseTags ? this.collapseTags = true : this.collapseTags
            this.isFilter ? this.filterable = true : this.filterable
            this.isPanel ? this.panel = true : this.panel 
            this.isClearable ? this.clearable = false : this.clearable
        },
        change(val){
            this.$emit('change',val)
        },
        expandChange(val){
            this.$emit('expandChange',val)
        },
        focus(){
            this.$emit('foucs')
        },
        blur(){
            this.$emit('blur')
        },
        removeTag(tag){
            this.$emit('removeTag',tag)
        }
    }
}
</script>